import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrganizationLevelPermissions } from '../models/organizationLevelPermissions';
import { CrudService } from '../shared/grid/crud.service';

@Injectable({
    providedIn: 'root'
})
export class OrganizationLevelPermissionsService extends CrudService<OrganizationLevelPermissions> {

    constructor(http: HttpClient) {
        super('OrganizationLevelPermissions', http);
    } 
}
